import { trace } from '../../../configuration/setup/trace';

export const SELECT_POIS_EVENT = 'EVENT_SELECT_POIS';

export const selectPoisHandler = (data: string[]) => {
    trace.debug('Selected Pois data:', data);
};
